import * as React from 'react';

export const StrainIndexReportIcon: React.FC = () => {
	return (
		<svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_382_27167)">
				<path
					d="M4.24993 17.25H6.23692C6.37438 17.25 6.48685 17.1375 6.48685 17V9.02188H23.0013V11.2906C23.0013 11.35 23.02 11.4063 23.0575 11.4531C23.0786 11.4801 23.1048 11.5027 23.1346 11.5195C23.1644 11.5363 23.1972 11.5471 23.2312 11.5511C23.2652 11.5552 23.2996 11.5525 23.3326 11.5432C23.3655 11.5339 23.3962 11.5181 23.4231 11.4969L27.9 7.98126C28.0344 7.82501 28.0125 7.65938 27.9 7.56876L23.4231 4.05626C23.377 4.0194 23.3196 3.99953 23.2606 4.00001C23.1169 4.00001 22.9982 4.11876 22.9982 4.26251V6.53126H6.24004C5.00599 6.53126 4 7.53751 4 8.77501V17C4 17.1375 4.11247 17.25 4.24993 17.25ZM27.7438 14.75H25.7568C25.6194 14.75 25.5069 14.8625 25.5069 15V22.9781H8.99245V20.7094C8.99245 20.65 8.9737 20.5938 8.93621 20.5469C8.91517 20.5199 8.88899 20.4973 8.85918 20.4805C8.82938 20.4637 8.79654 20.4529 8.76256 20.4489C8.72858 20.4448 8.69413 20.4475 8.6612 20.4568C8.62827 20.4661 8.5975 20.4819 8.57068 20.5031L4.09373 24.0188C3.95939 24.175 3.98125 24.3406 4.09373 24.4313L8.57068 27.9438C8.61755 27.9813 8.67378 28 8.73314 28C8.87685 28 8.99557 27.8813 8.99557 27.7375V25.4688H25.76C26.994 25.4688 28 24.4625 28 23.225V15C27.9938 14.8625 27.8813 14.75 27.7438 14.75Z"
					fill="#262626"
				/>
			</g>
			<defs>
				<clipPath id="clip0_382_27167">
					<rect width="32" height="32" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
